import React from 'react'
import './LogoShowcase.css'

const LogoShowcase: React.FC = () => {
  return (
    <div className="logo-showcase-container">
      <div className="logos-wrapper">
        <div className="logo-container">
          <img src="/imgs/METR.png" alt="Company Logo 1" className="logo" />
        </div>
        <div className="logo-container">
          <img src="/imgs/CAS.png" alt="Company Logo 2" className="logo" />
        </div>
        <div className="logo-container">
          <img src="/imgs/AISA.png" alt="Company Logo 3" className="logo" />
        </div>
      </div>
    </div>
  )
}

export default LogoShowcase
